const HeaderUX = () => {
    const $parent = $('header.main-header');
    if ($parent.length <= 0) return;

    // Cookie utility functions
    function setCookie(name, value, days) {
        const d = new Date();
        d.setTime(d.getTime() + (days * 24 * 60 * 60 * 1000));
        const expires = "expires=" + d.toUTCString();
        document.cookie = name + "=" + value + ";" + expires + ";path=/";
    }

    function getCookie(name) {
        const cname = name + "=";
        const decodedCookie = decodeURIComponent(document.cookie);
        const ca = decodedCookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i].trim();
            if (c.indexOf(cname) == 0) {
                return c.substring(cname.length, c.length);
            }
        }
        return "";
    }

    // Search functionality
    const $searchToggle = $parent.find('.search-toggle');
    const $searchDropdown = $parent.find('.search-dropdown');
    $searchToggle.click(() => {
        $searchDropdown.stop().fadeToggle().toggleClass('shown').find('input[name="q"]').focus();
    });

    // Close search dropdown when clicked outside
    $(window).click(() => {
        if (!$('.search-dropdown').hasClass('shown')) return;
        $('.search-dropdown').stop().fadeOut().removeClass('shown');
    });
    $parent.click(e => e.stopPropagation());

    // Inline menu dropdown functionality
    const $inlineMenuBackground = $parent.find('.inline-menu-dropdown');
    const $imbHeight = $parent.find('.inline-menu-dropdown .height-offset');
    const $subMenu = $parent.find('.header-inline-nav .sub-menu-wrapper');
    const $toggleSubMenu = $parent.find('.header-inline-nav .first-level-menu.has-sub-menu');
    
    let currentMaxHeight = 0;
    $subMenu.each(function() {
        const elHeight = $(this).height();
        if (elHeight > currentMaxHeight) {
            currentMaxHeight = elHeight;
        }
    });
    $imbHeight.height(currentMaxHeight);

    $(window).resize(() => {
        $subMenu.each(function() {
            const elHeight = $(this).height();
            if (elHeight > currentMaxHeight) {
                currentMaxHeight = elHeight;
            }
        });
        $imbHeight.height(currentMaxHeight);
    });

    $toggleSubMenu.on('mouseenter', () => {
        $parent.addClass('inline-dropdown-toggled');
        $inlineMenuBackground.stop().slideDown(400);
        $subMenu.delay(300).stop().fadeIn(400);
    });

    $parent.on('mouseleave', () => {
        if (!$parent.hasClass('inline-dropdown-toggled')) return;
        $inlineMenuBackground.delay(300).stop().slideUp(400);
        $subMenu.stop().fadeOut(400);
    });

    // Mobile menu functionality
    const $burger = $parent.find('.burger');
    const $closeBtn = $parent.find('.mobile-menu-dropdown .close-btn');
    const $mobMenu = $('.mobile-menu-dropdown');
    const $mobToggleAccord = $('.mobile-menu-dropdown .sub-menu-toggle');

    $burger.click(() => $mobMenu.stop().slideDown());
    $closeBtn.click(() => $mobMenu.stop().slideUp());

    $mobToggleAccord.click(function() {
        if (!$(this).hasClass('toggled')) {
            $('.mobile-menu-dropdown .sub-menu-toggle.toggled').next('.sub-menu-dropdown').stop().slideUp(400).end().removeClass('toggled');
            $(this).addClass('toggled').next('.sub-menu-dropdown').stop().slideDown();
        } else {
            $(this).next('.sub-menu-dropdown').stop().slideUp();
            $(this).removeClass('toggled');
        }
    });

    $mobToggleAccord.first().addClass('toggled').next('.sub-menu-dropdown').stop().slideDown();

// Site announcement functionality
const $announcement = $("#site-announcement");
if ($announcement.length > 0) {
    const $closeAnnounce = $("#closeAnnouncement");
    
    // Ensure the close button is visible
    $closeAnnounce.show();
    
    // Get the UID from the data-uid attribute of the announcement
    const announcementUID = $announcement.data('uid');
    const cookieName = 'announcementClosed-' + announcementUID;

    const announcementCookie = getCookie(cookieName);
    if (announcementCookie !== 'true') {
        $announcement.show();
    }

    $closeAnnounce.click(() => {
        $announcement.slideUp(400);
        setCookie(cookieName, 'true', 1); // Set the cookie with the unique name
    });

    console.log("Announcement UID:", announcementUID);
    console.log("Announcement Cookie:", cookieName);
    console.log("Announcement Value:", announcementCookie);
}


}

export default HeaderUX;


// console.log("Announcement UID:", announcementUID);
// console.log("Cookie name:", cookieName);
// console.log("Announcement cookie value:", announcementCookie);